/**
 * Developer portal — update `url` when the portal launches.
 */
export const developerPortal = {
  url: 'https://developers.nodemos.at',
  label: 'NODEMOS Developer Portal',
  shortLabel: 'Developer portal',
}